export default __webpack_public_path__ + "static/media/Threaded Holes.fdcba3df.jpg";